var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "group-wallet-table",
      class: { "az-card-bordered": !_vm.loading }
    },
    [
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex align-center flex-wrap mb-4" },
            [
              _c("span", { staticClass: "az-ds-card-title" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "", "max-width": "360" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass:
                                      "group-wallet-table__explain ml-2",
                                    attrs: {
                                      type: "button",
                                      "aria-label": _vm.explainerLink
                                    },
                                    on: { click: _vm.explainTotal }
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: "mdi-information",
                                    size: 16,
                                    color: "#8E8E8E"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    641273561
                  )
                },
                [_c("span", [_vm._v(_vm._s(_vm.explainerLink))])]
              ),
              _c("v-spacer"),
              _vm.isFiltered
                ? _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c("span", { staticClass: "az-text-secondary mr-2" }, [
                        _vm._v(_vm._s(_vm.filteredLabel))
                      ]),
                      _c(
                        "BaseButton",
                        {
                          attrs: { underlined: "", fitContent: "" },
                          on: { click: _vm.clearFilter }
                        },
                        [_vm._v(" Ver o grupo completo ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.loading,
            noData: _vm.isEmpty,
            message: _vm.emptyMessage,
            minHeight: 280
          }
        },
        [
          _c(
            "div",
            { staticClass: "group-wallet-table__scroll table-new-ux-v1" },
            [
              _c("table", { staticClass: "group-wallet-table__table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.displayColumns, function(column) {
                      return _c(
                        "th",
                        {
                          key: column.key,
                          class: column.className,
                          attrs: { scope: "col" }
                        },
                        [_vm._v(" " + _vm._s(column.label) + " ")]
                      )
                    }),
                    0
                  )
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.displayRows, function(row) {
                    return _c(
                      "tr",
                      { key: row.id },
                      _vm._l(row.cells, function(cell) {
                        return _c(
                          "td",
                          { key: cell.key, class: cell.className },
                          [
                            _c(
                              "div",
                              { staticClass: "group-wallet-table__value" },
                              [
                                cell.key === "membro"
                                  ? _c("span", {
                                      staticClass: "group-wallet-table__dot",
                                      style: { backgroundColor: row.color }
                                    })
                                  : _vm._e(),
                                _c("span", [_vm._v(_vm._s(cell.text))])
                              ]
                            ),
                            cell.secondary
                              ? _c(
                                  "div",
                                  { staticClass: "group-wallet-table__sub" },
                                  [_vm._v(" " + _vm._s(cell.secondary) + " ")]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  }),
                  0
                ),
                _vm.displayTotalRow
                  ? _c("tfoot", [
                      _c(
                        "tr",
                        { staticClass: "group-wallet-table__total" },
                        _vm._l(_vm.displayTotalRow.cells, function(cell) {
                          return _c(
                            "th",
                            {
                              key: cell.key,
                              class: cell.className,
                              attrs: { scope: "row" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "group-wallet-table__value" },
                                [_c("span", [_vm._v(_vm._s(cell.text))])]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._l(_vm.notas, function(nota, indice) {
            return _c(
              "div",
              { key: indice, staticClass: "az-info-note mt-3" },
              [
                _c("icon-svg", {
                  staticClass: "flex-shrink-0",
                  attrs: { name: "info-circle", size: 12 }
                }),
                _c("span", [_vm._v(_vm._s(nota))])
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }